import React, { useCallback, useState, useEffect, useRef } from "react";

import Site from "./Site";

import { useUserProvider } from "../context/UserProvider";
import { useSiteProvider } from "../context/SiteProvider";

import SignInForm from "./SignInForm";

// import Loader from "./Loader";

import {
  CssBaseline,
  Typography,
  Paper,
  Card,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const Sites = ({ existingFied, role }) => {
  const { user } = useUserProvider();
  const { sites } = useSiteProvider();

  return (
    <>
      <CssBaseline />
      {/* 
      {sites.length === 0 ? (
        <Typography
          variant="h4"
          color="textSecondary"
          component="h2"
          gutterBottom
        >
          No Site Found
        </Typography>
      ) : ( */}
      {/* <CardHeader title="Latest Sites" /> */}
      {/* <TableContainer component={Paper} elevation={0}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === "dark" ? "#001E3C" : "#F0F2F7",
            }}
          >
            <TableRow>
              {user ? (
                <>
                  <TableCell>Date</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="right">Delete</TableCell>
                  <TableCell align="right"></TableCell>
                </>
              ) : (
                <>
                  <TableCell>Date</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="right">Delete</TableCell>
                  <TableCell align="right"></TableCell>
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody> */}
      {/* ---- Display depending role ---- */}
      {/* {user && role != "pending" ? ( */}
      <>
        {sites.map((site) =>
          site.id != "T7sw6D8qKfwHV82FfmC2" &&
          site.id != "nVpUyc638uRLc1xAAjQS" ? (
            <>
              <Site
                key={site.id}
                {...site}
                {...user}
                existingField={existingFied}
              />
            </>
          ) : (
            ""
          )
        )}
      </>
      {/* ) : user && role === "pending" ? (
        <Typography>Coucou</Typography>
      ) : !user ? (
        <SignInForm />
      ) : (
        ""
      )} */}
      {/* ---- Display depending role END ---- */}
      {/* </TableBody>
        </Table>
      </TableContainer> */}
      {/* )} */}
    </>
  );
};

export default Sites;
